import '../styles/blog.scss';
import '../scripts/Client/script.js';